import React from 'react'

export default function New(props) {
  return (
    <div>New</div>
  )
}
